import { NavBottomPadding, TxtLimit, TxtLimit2 } from '@styles/base.style'
import styled from '@themes/theme'

export const ClubPortalWrap = styled.div`
  position: relative;
  display: block;
  height: auto;
  margin-top: -34px;
  .club-portal-top {
    width: 100%;
    .club-division {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 15px;
      padding: 0 25px 0 31px;
      margin-top: 50px;
      margin-bottom: -16px;
      .superior-club-badge-info {
        &--txt {
          color: ${props => props.theme.color.themeTxt};
          font-size: ${props => props.theme.font.small};
        }
         img {
            width: 11px;
            height: auto;
            margin-right: 4px;
         }
      }
      .free-club-info {
        margin-left: -5px;
        line-height: 31px;
        color: ${props => props.theme.color.gray};
        font-size: ${props => props.theme.font.small};
      }
      .club-select-drop-down {
        margin-left: auto;
        .ant-select-selection-selected-value {
          padding-right: 20px;
        }
        .option-txt {
          font-size: ${props => props.theme.font.medium} !important;
        }
        .ant-select-dropdown {
          width: 80px !important;
        }
      }
    }
    .club-portal-tit {
      position: relative;
      padding: 53px 25px 0;
      font-size: 2.2rem;
      line-height: 2.6rem;
      letter-spacing: -0.7px;
      &--img {
         width: 222px;
         height: auto;
      }
    }
  }
  .club-portal-list {
    position: relative;
    width: 100%;
    height: auto;
    margin-top: 36px;
    padding: 0 14px ${NavBottomPadding};
    &--item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 130px;
      margin-bottom: 10px;
      padding: 16px 16px 16px 18px;
      background: ${props => props.theme.color.subColor} !important;
      border-radius: 18px;
      &:not(.aos-animate) {
        transform: translate3d(0,200,0) !important;
      }
      &.aos-animate {
        transform: translate3d(0,0,0) !important;
      }
      .club-info {
        position: relative;
        flex: 1;
        max-width: calc(100% - 110px);
        margin-left: 10px;
        .club-name {
          font-size: ${props => props.theme.font.large};
          font-weight: ${props => props.theme.fontW.bold};
          line-height: 20px;
          color: ${props => props.theme.color.themeTxt};
          margin-bottom: 3px;
        }
        &--notice {
          display: flex;
          flex-wrap: wrap;
          &--tit {
            width: 100%;
            color: ${props => props.theme.color.themeTxt};
            font-size: ${props => props.theme.font.small};
            ${TxtLimit};
            line-height: 1.5rem;
            margin-bottom: 2px;
          }
          &--contents {
            width: 100%;
            min-height: 31px;
            color: ${props => props.theme.color.darkTxt};
            font-size: ${props => props.theme.font.small};
            font-weight: ${props => props.theme.fontW.regular};
            ${TxtLimit2};
            max-height: 3rem;
            line-height: 1.5rem;
          }
          &--btn {
            z-index: 0;
            display: flex;
            align-items: center;
            font-size: ${props => props.theme.font.small};
            svg {
              width: auto;
              height: 4px;
              transform: rotate(-90deg);
            }
            // 상세 보기 버튼
            &.more {
              width: 58px;
              height: 22px;
              line-height: 2.2rem;
              text-align: left;
              background: none;
              span {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translate(0, -50%);
                color: ${props => props.theme.color.btn};
                font-size: ${props => props.theme.font.small};
              }
              svg {
                position: absolute;
                top: 50%;
                right: 8px;
                transform: translate(0, -65%) rotate(-90deg);
                path {
                  fill: ${props => props.theme.color.btn};
                }
              }
            }
            // 클럽 이동 및 현재 클럽 버튼
            &.go-club {
              position: absolute;
              right: 0;
              bottom: 0;
              width: 64px;
              height: 20px;
              background: ${props => props.theme.color.darkTxt};
              .btn-txt {
                  position: absolute;
                  top: 50%;
                  left: 8px;
                  transform: translate(0, -50%);
                  color: #000000;
                  font-size: ${props => props.theme.font.small};

                & + svg {
                  position: absolute;
                  top: 50%;
                  right: 7px;
                  transform: translate(0, -60%) rotate(-90deg);
                  path {
                    fill: #000000;
                  }
                }
              }
              // 현재 클럽 위치
              &.current-club {
                background: ${props => props.theme.color.underover};
                .btn-txt {
                  &.go-club {
                    display: none;
                  }
                  &.current {
                    display: block;
                  }
                }
              }
            }
          } /* club-info--notice--btn */
        } /* club-info--notice */
      } /* club-info */
    } /* club-portal-list--item */
  } /* club-portal-list */
`
export const ClubSignature = styled.div`
  position: relative;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  background: ${props => props.theme.color.mainColor};
  .badge {
    position: absolute;
    top: 0;
    left: 0;
    width: 17px;
  }
  .img-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 86px;
    height: 86px;
    max-width: 86px;
    max-height: 86px;
    border-radius: 50%;
    overflow: hidden;
    .emblem {
      width: 100%;
      height: 100%;
      object-fit: cover;
      &.alternate-emblem {
        object-fit: contain;
        margin-top: 8px;
        max-height: 48px;
      }
    }
  }
  &.club-info {
    display: block;
    margin: 30px auto 50px;
    position: relative;
    .name {
      position: absolute;
      top: 94px;
      left: 50%;
      width: auto;
      white-space: nowrap;
      transform: translateX(-50%);
      color: ${props => props.theme.color.themeTxt};
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
    }
  }
`
export const ShowDetail = styled.span`
  min-height: 65px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
`
